import { Geometry } from '../renderer/geometry';

const SEGMENTS = 24;
const RADIUS = 0.12;
const HEIGHT = 0.025;

// Generate a small cylinder for ceiling light fixtures.
// Top face sits at y=0 (flush with ceiling), bottom face at y=-HEIGHT.
// Only bottom disk and side walls are generated (top is hidden by ceiling).
export function generateCeilingLightGeometry(): Geometry {
  const vertices: number[] = [];

  // Precompute circle points
  const circleX: number[] = [];
  const circleZ: number[] = [];
  for (let i = 0; i < SEGMENTS; i++) {
    const angle = (i / SEGMENTS) * Math.PI * 2;
    circleX.push(Math.cos(angle) * RADIUS);
    circleZ.push(Math.sin(angle) * RADIUS);
  }

  // Bottom disk (normal pointing down)
  const ny = -1;
  for (let i = 0; i < SEGMENTS; i++) {
    const next = (i + 1) % SEGMENTS;
    // CCW winding when viewed from below: center, current, next
    vertices.push(0, -HEIGHT, 0, 0, ny, 0, 0, 0, 0);
    vertices.push(circleX[i], -HEIGHT, circleZ[i], 0, ny, 0, 0, 0, 0);
    vertices.push(circleX[next], -HEIGHT, circleZ[next], 0, ny, 0, 0, 0, 0);
  }

  // Side walls
  for (let i = 0; i < SEGMENTS; i++) {
    const next = (i + 1) % SEGMENTS;

    // Outward-pointing normals (average of the two edge normals approximated by radial direction)
    const nx0 = circleX[i] / RADIUS;
    const nz0 = circleZ[i] / RADIUS;
    const nx1 = circleX[next] / RADIUS;
    const nz1 = circleZ[next] / RADIUS;

    // Two triangles per quad: top is y=0, bottom is y=-HEIGHT
    // Triangle 1: top-current, bottom-next, bottom-current
    vertices.push(circleX[i], 0, circleZ[i], nx0, 0, nz0, 0, 0, 0);
    vertices.push(circleX[next], -HEIGHT, circleZ[next], nx1, 0, nz1, 0, 0, 0);
    vertices.push(circleX[i], -HEIGHT, circleZ[i], nx0, 0, nz0, 0, 0, 0);

    // Triangle 2: top-current, top-next, bottom-next
    vertices.push(circleX[i], 0, circleZ[i], nx0, 0, nz0, 0, 0, 0);
    vertices.push(circleX[next], 0, circleZ[next], nx1, 0, nz1, 0, 0, 0);
    vertices.push(circleX[next], -HEIGHT, circleZ[next], nx1, 0, nz1, 0, 0, 0);
  }

  return {
    vertices: new Float32Array(vertices),
    vertexCount: vertices.length / 9
  };
}
